<template>
  <div>
    <local-style
      class="template-styles"
      :options="options"
      :container_id="ids.container_id"
      :rect_id="ids.rect_id"
      elementType="cxShare"
      :styleImgs="styleImgs"
      ref="localStyleComponent"
    />
  </div>
</template>

<script>
import localStyle from "toolbarComponents/styles/local-style.vue"
export default {
  name: "share-options-style",
  components: { localStyle },
  props: {
    options: Object
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    buttonStyles() {
      let menu =
        this.request_prefix === "bigScreen" ? this.$store.state.bigScreenMenu.menu : this.$store.state.menu.menu
      let styles = [],
        stylesOption = []
      for (let i = 0; i < menu.children.length; i++) {
        if (menu.children[i].type !== "element" && menu.children[i].type !== "baseElement") {
          continue
        }
        for (let j = 0; j < menu.children[i].children.length; j++) {
          if (menu.children[i].children[j].type === "cxShare") {
            styles = menu.children[i].children[j].children
            break
          }
        }
      }
      styles.forEach(item => {
        stylesOption.push(item.attribute.options)
      })
      return stylesOption
    },
    showStyles() {
      return this.buttonStyles.length > this.showLen ? this.buttonStyles.slice(0, this.showLen) : this.buttonStyles
    },
    moreStyles() {
      return this.buttonStyles.length > this.showLen ? this.buttonStyles.slice(this.showLen) : []
    },
  },
  data() {
    return {
      activeIndex: undefined,
      activeNames: [],
      showLen: 6,
      styleImgs: [require("assets/images/leftMenu/share/style1.png"),require("assets/images/leftMenu/share/style2.png")],
    }
  },
  methods: {
    changeButtonStyle(style, index) {
      this.activeIndex = index
      let tmpData = JSON.parse(JSON.stringify(style))
      let curOptions = this.$getOptions()
      tmpData.left = curOptions.left
      tmpData.top = curOptions.top
      tmpData.width = curOptions.width
      tmpData.height = curOptions.height
      let data = {
        ...this.ids,
        options: tmpData
      }
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
    },
    showAllStyles() {
      this.$refs.localStyleComponent.showAllStyles()
    }
  }
}
</script>

<style lang="scss" scoped>
.button-styles {
  justify-content: space-between;
  flex-wrap: wrap;
  .button-style-item {
    // min-width: 33%;
    width: calc((100% - 16px) / 3);
    margin: 0 4px 12px;
    box-sizing: border-box;
    border-radius: 4px;
    // border: 1px solid #e9e9e9;
    text-align: center;
    &:nth-child(3n + 1) {
      margin-left: 0;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.active {
      .img-style-box {
        border: 1px solid var(--themeColor);
        box-shadow: 0 0 0 1px var(--themeColor);
        .icon-checked {
          display: block;
        }
      }
    }
    .img-style-box {
      position: relative;
      height: 53px;
      line-height: 53px;
      border-radius: 4px;
      margin-bottom: 8px;
      background-color: var(--styleBgColor);
      border: 1px solid var(--styleBgColor);
      .icon-checked {
        position: absolute;
        right: 0;
        top: 0;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/images/icon-checked.png);
        background-size: 100% 100%;
        display: none;
      }
    }
  }
  .button-item {
    width: 100%;
    border: none;
    padding: 0;
  }
}
</style>
